import React from "react";
import img from "../../media/images/Full-Body-Hair-Removal-For-Male-Salon.png"
import img1 from "../../media/images/delhi.png"
import img2 from "../../media/images/noida.png"
import img3 from "../../media/images/greater-noida.png"
import img4 from "../../media/images/gurgaon.png"
import img5 from "../../media/images/ghaziabad.png"
import img6 from "../../media/images/faridabad.png"
import img7  from "../../media/images/banglore_loc.png"
import img8  from "../../media/images/maharastra_loc.png"

const LandingLocationComponent = () => {
  return (
    <div>
      <div className="location">
        <div>
          <h2 className="location-heading">GLAZMA MEN'S SALON AT HOME SERVICED AREA</h2>
          <div className="location-icon"><img title="location icon" src={img} alt="icon" /></div>
          <div className="location-col">

            <a href="#services"  className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img1} alt="location-icon" /></div>
              <div className="location-list-text">Delhi</div>
            </a>
            

            <a href="#services" title="Cheap Waxing Near Me" className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img2} alt="location-icon" /></div>
              <div className="location-list-text">Noida</div>
            </a>
            

            <a href="#services"  title="Best Way To Get Rid Of DELICATE AREAS Hair" className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img3} alt="location-icon" /></div>
              <div className="location-list-text">Greater Noida</div>
            </a>
            

            <a href="#services"  className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img4} alt="location-icon" /></div>
              <div className="location-list-text">Gurgaon</div>
            </a>
            

            <a href="#services"  title="Underarm Waxing Near Me" className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img5} alt="location-icon" /></div>
              <div className="location-list-text">Ghaziabad</div>
            </a>
            

            <a href="#services"   className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img6} alt="location-icon" /></div>
              <div className="location-list-text">Faridabad</div>
            </a>
            

                    {/* <a href="#services"   className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img7} alt="location-icon" /></div>
              <div className="location-list-text">Benglauru</div>
            </a>


                    <a href="#services"   className="location-list">
              <div className="location-list-icon"><img title="location icon" src={img8} alt="location-icon" /></div>
              <div className="location-list-text">Maharashtra</div>
            </a> */}

            
            
            
          </div>

          <a href="#services" className="landing-page-button-web-yellow landing-page-button-black">
                  Book Service Now
                  </a>

                  
                  <a href="#services" className="landing-page-button-mobile-yellow landing-page-button-black">
                  Book Service Now
                  </a>
          
        </div>
      </div>
    </div>
  );
};

export default LandingLocationComponent;
